import React, { useState, useEffect, } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { IonContent, IonHeader, IonPage, IonButton, IonFab, IonFabList, IonFabButton, 
         IonIcon, IonLabel, IonLoading, IonAlert, IonItem } from '@ionic/react';
import { ActivityTypes, ActivityColors, EnumTimePeriods, EnumPersons } from '../domain/enums';
import { IActivityLogSearchResult, ILogSearch_Response } from '../domain/ActivityLog';
import { getActivityLogListAsync } from '../services/asyncDataService';
import LogItemList  from '../components/LogItemList';
import HeaderApp from '../components/HeaderApp';
import { Plugins } from '@capacitor/core';
import { add, ellipse, lockClosedOutline} from 'ionicons/icons';
import './css/Home.css';

const { Network } = Plugins;

const Home: React.FC<RouteComponentProps> = ({history, location, match}) => {

  const [openList, setOpenList] = useState([] as IActivityLogSearchResult[]);
  const [showLoading, setShowLoading] = useState(false);
  const [pinValue, setPinValue] = useState(0);
  const [recentValue, setRecentValue] = useState(0);
  const [allowTimeLogAdd, setAllowTimeLogAdd] = useState(true);
  const [alerVisible, setAlertVisible] = useState(false);
  const [isOnline, setIsOnline] = useState<boolean>(window.localStorage.getItem("online") !== "0");
  const [showToast, setShowToast] = useState(false);
  const [hasBeenRefreshed, setHasBeenRefreshed] = useState(false);
  const [myException, setMyException] = useState("");
  const [errorVisible, setErrorVisible] = useState(false);

  useEffect(() => {
    Network.addListener("networkStatusChange", status => {
      setIsOnline(status.connected);
      if (status.connected)
        window.localStorage.setItem("online", "1");
      else
        window.localStorage.setItem("online", "0");
    });

    return () => Network.removeAllListeners();
  },[])

  useEffect(() => {
    if (isOnline) {
      tokenAndOnline();
    }
    else {
      setShowToast(true);
    }
  },[isOnline]);

   //update pin value after delete
  useEffect(() => {
    if (hasBeenRefreshed && isOnline) {
      refreshAndOnline();
    }
  },[hasBeenRefreshed, isOnline])

  const tokenAndOnline = async() => {
    let _token = String(window.localStorage.getItem("token"));
    let _username = window.localStorage.getItem("username");
    let _client = window.localStorage.getItem("defaultClient") ? String(window.localStorage.getItem("defaultClient")) : '-1' ;

    //call to get the data
    console.log("call to get the data");
    setShowLoading(true);
    let expectedData = await getActivityLogListAsync(_token, _client, EnumTimePeriods.All.toString(), '', '', 
                                                     String(_username), '', Number(ActivityTypes.All), false , '', 
                                                     true)
    if (expectedData && expectedData.data) {
      let activityLogList = (JSON.parse(expectedData.data.toString()) as ILogSearch_Response).Results as IActivityLogSearchResult[];
      if (activityLogList.length > 0) {
        console.log("call to get the data - length > 0");
        let foundTimeLog = activityLogList.find((x) =>  x.ActivityLogEntryTypeID === Number(ActivityTypes['Time Log']) && x.LoginID === _username);
        if (foundTimeLog){
          setAllowTimeLogAdd(false);
        }
        setOpenList(activityLogList);
        setShowLoading(false);
      }
      else 
        setShowLoading(false);
    }
    else {
      setShowLoading(false);
      setMyException("Details: " + JSON.stringify((expectedData as any)));
      setErrorVisible(true);
    }
          
    //call to display pin value
    console.log("call to display pin value");
    let expectedDataPinned = await getActivityLogListAsync(_token, _client, EnumTimePeriods.All.toString(), '', '', 
                                                EnumPersons.All.toString(), '', Number(ActivityTypes.All), true , '', 
                                                false);
    if (expectedDataPinned && expectedDataPinned.data) {
      let activityLogPinnedList = (JSON.parse(expectedDataPinned.data.toString()) as ILogSearch_Response).Results as IActivityLogSearchResult[];
      if (activityLogPinnedList.length > 0) {
        console.log("call to display pin value - length > 0");
        window.localStorage.setItem("pinValue", activityLogPinnedList.length.toString());
        setPinValue(activityLogPinnedList.length);
      }
    }
    else {
      setMyException("Details: " + JSON.stringify((expectedDataPinned as any)));
      setErrorVisible(true);
    }
              
    //call to display recent value
    console.log("call to display recent value");
    let expectedDataRecent = await getActivityLogListAsync(_token, _client, EnumTimePeriods['Past 24 Hours'].toString(), '', '', 
                                            EnumPersons.All.toString(), '', Number(ActivityTypes.All), false , '', 
                                            false);
    if (expectedDataRecent && expectedDataRecent.data) {
      let activityLogRecentList = (JSON.parse(expectedDataRecent.data.toString()) as ILogSearch_Response).Results as IActivityLogSearchResult[];
      if (activityLogRecentList.length > 0) {
        console.log("call to display recent value - length > 0");
        window.localStorage.setItem("recentValue", activityLogRecentList.length.toString());
        setRecentValue(activityLogRecentList.length);
      }
    }
    else {
      setMyException("Details: " + JSON.stringify((expectedDataRecent as any)));
      setErrorVisible(true);
    }
  }

  const refreshAndOnline = async() => {
    let _token = window.localStorage.getItem("token");
    let _client = window.localStorage.getItem("defaultClient") ? String(window.localStorage.getItem("defaultClient")) : '-1';

    console.log('pinned in refreshAndOnline');
    let expectedDataPinned = await getActivityLogListAsync(String(_token), _client, EnumTimePeriods.All.toString(), '', '', EnumPersons.All.toString(), '', Number(ActivityTypes.All), true , '', false)
    if (expectedDataPinned && expectedDataPinned.data) {
      let activityLogPinnedList = (JSON.parse(expectedDataPinned.data.toString()) as ILogSearch_Response).Results as IActivityLogSearchResult[];
      if (activityLogPinnedList.length > 0) {
        window.localStorage.setItem("pinValue", activityLogPinnedList.length.toString());
        setPinValue(activityLogPinnedList.length);
      } 
    }
    else {
      setMyException("Details: " + JSON.stringify((expectedDataPinned as any)));
      setErrorVisible(true);
    }

    console.log('recent in refreshAndOnline');     
    let expectedDataRecent = await getActivityLogListAsync(String(_token), _client, EnumTimePeriods['Past 24 Hours'].toString(), '', '', EnumPersons.All.toString(), '', Number(ActivityTypes.All), false , '', false)
    if (expectedDataRecent && expectedDataRecent.data) {
      let activityLogRecentList = (JSON.parse(expectedDataRecent.data.toString()) as ILogSearch_Response).Results as IActivityLogSearchResult[];
      if (activityLogRecentList.length > 0) {
        window.localStorage.setItem("recentValue", activityLogRecentList.length.toString());
        setRecentValue(activityLogRecentList.length);
      } 
    }
    else {
      setMyException("Details: " + JSON.stringify((expectedDataRecent as any)));
      setErrorVisible(true);
    }
  }

  const createActivityLog = (activityType: string) => {
    if (isOnline) {
      if (Number(activityType) === Number(ActivityTypes['Time Log']) && !allowTimeLogAdd)
        setAlertVisible(true);
      else if (!window.localStorage.getItem("defaultClient"))
        history.push('/activity/0/0/' + activityType + '/0/0/0/0/0'); 
      else {
        let clientId = String(window.localStorage.getItem("defaultClient")); 
        history.push('/activity/0/' + clientId + '/' + activityType + '/0/0/0/0/0'); 
      }
    }
    else 
      setShowToast(true);
  }

  const refresh = (id:number, isDelete:boolean = true) => {
    setHasBeenRefreshed(false);
    if (id !== 0) {
      let itemToRemove: IActivityLogSearchResult[] = openList.filter((x) => x.ActivityLogID === id);
      if (itemToRemove.length === 1 && itemToRemove[0].ActivityLogEntryTypeID === Number(ActivityTypes['Time Log'])){
        setAllowTimeLogAdd(true);
      }
      setOpenList(openList.filter((x) => x.ActivityLogID !== id)); 
      setHasBeenRefreshed(true);
      //window.localStorage.setItem("activityLogListOpen", JSON.stringify(openList));
    }
  }
 
  return (
    <IonPage>
      <IonHeader mode="ios">
          <HeaderApp pinValue={pinValue} recentValue={recentValue} history={history} location={location} match={match} isOnline={isOnline}></HeaderApp>
      </IonHeader>
      <IonContent fullscreen>
        {openList.length > 0 &&
          <LogItemList resultList={openList} history={history} location={location} match ={match} refresh={refresh}></LogItemList> 
        }
        {openList.length === 0 &&
          <IonItem className="my-ion-item-noopen">
            <IonIcon icon={lockClosedOutline} slot="start" color="primary" />
            <IonLabel color="primary">No open activity log entries.</IonLabel>
          </IonItem>
        }
        <IonFab vertical="bottom" horizontal="end" slot="fixed">
            <IonFabButton mode="ios" class="my-fab-button">
              <IonIcon mode="ios" icon={add} />
            </IonFabButton>
            <IonFabList class= "myFabList" side="top">
              { Object.keys(ActivityTypes).filter((x:any) => !isNaN(Number(ActivityTypes[x])) && Number(ActivityTypes[x]) !== 0)
                  .sort ((a:any,b:any) => Number(ActivityTypes[b]) - Number(ActivityTypes[a]))
                  .map((x:any) => {
                    return (
                      <IonButton mode="ios" class="myFabButton" color="light" key={ActivityTypes[x]} onClick={() => {createActivityLog(ActivityTypes[x])}}>
                        <IonIcon mode="ios" icon={ellipse} className="my-ion-icon" color={ActivityColors[Number(ActivityTypes[x])]} size="smaller"></IonIcon> 
                        <IonLabel mode="ios">{x}</IonLabel>
                      </IonButton> 
                    )
                  })
              }  
            </IonFabList>
          </IonFab>  
      </IonContent>
      <IonLoading mode="ios"
        cssClass='my-loading'
        isOpen={showLoading}
        onDidDismiss={() => setShowLoading(false)}
        message={'Getting data...'}
      />
      <IonAlert mode="ios"
        isOpen={alerVisible}
        onDidDismiss={() => setAlertVisible(false)}
        cssClass='my-custom-class'
        header={'Warning'}
        subHeader={''}
        message={'There is already an open time sheet entry for this person.'}
        buttons={['OK']}
      /> 
      <IonAlert mode="ios"
        isOpen={errorVisible}
        onDidDismiss={() => setErrorVisible(false)}
        cssClass='my-custom-class'
        header={'Error'}
        subHeader={myException}
        message={''}
        buttons={['OK']}
      /> 
      <IonAlert mode="ios"
          isOpen={showToast}
          onDidDismiss={() => setShowToast(false)}
          cssClass='my-custom-class'
          header={'Warning'}
          subHeader={''}
          message={'You are in offline mode'}
          buttons={['OK']}
      /> 
    </IonPage>
  );
};

export default Home;